/**
 * WebSocket Service Starter
 * Initializes the AWS Vendor WebSocket service for real-time vendor notifications
 */

import awsVendorWebSocketService from './awsVendorWebSocketService';

let wsService = null;

/**
 * Start the WebSocket service to listen for vendor notifications
 */
export const startWebSocketService = () => {
  try {
    console.log('🚀 Starting WebSocket service for vendor notifications...');
    
    // Use the existing AWS Vendor WebSocket service instance
    wsService = awsVendorWebSocketService;
    
    // Connect to the WebSocket
    wsService.connect();
    
    // Add event listeners using the correct method
    if (wsService.addListener) {
      wsService.addListener('connected', (data) => {
        console.log('✅ WebSocket connected successfully:', data);
      });
      
      wsService.addListener('vendorAdded', (vendor) => {
        console.log('🆕 New vendor added:', vendor);
        // The RealTimeVendorMarketplace component will automatically update
      });
      
      wsService.addListener('vendorStatusChanged', (data) => {
        console.log('🔄 Vendor status changed:', data);
      });
      
      wsService.addListener('error', (error) => {
        console.error('❌ WebSocket error:', error);
      });
    } else {
      console.warn('⚠️ WebSocket service does not have addListener method');
    }
    
    console.log('✅ WebSocket service started successfully');
    
  } catch (error) {
    console.error('❌ Failed to start WebSocket service:', error);
  }
};

/**
 * Stop the WebSocket service
 */
export const stopWebSocketService = () => {
  try {
    if (wsService) {
      console.log('🛑 Stopping WebSocket service...');
      wsService.disconnect();
      wsService = null;
      console.log('✅ WebSocket service stopped');
    }
  } catch (error) {
    console.error('❌ Error stopping WebSocket service:', error);
  }
};

/**
 * Get the current WebSocket service instance
 */
export const getWebSocketService = () => {
  return wsService;
};

/**
 * Check if WebSocket service is running
 */
export const isWebSocketServiceRunning = () => {
  return wsService !== null && wsService.isConnected;
}; 